import { client } from '../client';
import { IOneReport } from './types/IOneReport';
import { IOneReportMedia } from './types/IOneReportMedia';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const addOneReportMedia = async (
  one_report_id: string,
  payload: IOneReportMedia,
  userRole?: string,
): Promise<IOneReport> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post<IOneReport>(`${prefix}/one_reports/${one_report_id}/media`, payload);

  return data;
};
